import React, { useState, useEffect } from 'react';
import './Insert-Video.scss';
import 'rc-pagination/assets/index.css';
import Pagination from 'rc-pagination';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';



const InsertVideo = (props) => {

    const config = new Configurations()


    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (!props.isOpen) {
            setVideoPrograma(null);
            setVideoEpisodio({ idEp: null, nomeEp: '', episodioSelecionado: null });
            setHasError(false)
        } else {
            carregaListaProgramasVideos();
        }
    }, [props.isOpen]);



    const [idVideoPrograma, setVideoPrograma] = useState(null);

    const [{ idEp, nomeEp, episodioSelecionado }, setVideoEpisodio] = useState({ idEp: null, nomeEp: '', episodioSelecionado: null }),
        selecionaEpisodio = (_episodio) => {
            setVideoEpisodio({ idEp: _episodio.idVideoEpisodio, nomeEp: _episodio.nome, episodioSelecionado: _episodio });
        }

    const nomePrograma = () => {
        const _programa = listaProgramasVideos.filter(item => item.idVideoPrograma === idVideoPrograma)[0];
        return _programa ? _programa.nome : '';
    }

    const { handleModalVideo, toggle, isLoadingInserirVideo, flagContent
    } = props;


    const
        onChangePage = (page) => {
            selecionaVideoPrograma(idVideoPrograma, page)
        }

    const [paginacaoEpisodiosVideos, setPaginacaoEpisodiosVideos] = useState({})
    const [isLoadingEpisodiosVideos, setIsLoadingEpisodiosVideos] = useState(false)
    const [listaEpisodiosVideos, setListaEpisodiosVideos] = useState([]);
    const episodiosPorPagina = 9;


    const selecionaVideoPrograma = (idVideoPrograma, pagina = 1) => {
        setIsLoadingEpisodiosVideos(true)
        setVideoPrograma(idVideoPrograma)

        axios.get(config.apiBasePath + `/videos/${idVideoPrograma}/episodios?pagina=${pagina}&limite=${episodiosPorPagina}`)

            .then(response => {
                setPaginacaoEpisodiosVideos(response.data.paginacao)
                setListaEpisodiosVideos(response.data.videosEpisodios)
                setHasError(false)
            })
            .catch(handleError)
            .finally(() => setIsLoadingEpisodiosVideos(false));
    }


    const [isLoadingProgramasVideos, setIsLoadingProgramasVideos] = useState(true)
    const [listaProgramasVideos, setListaProgramasVideos] = useState([])
    const carregaListaProgramasVideos = () => {
        setIsLoadingProgramasVideos(true)
        axios.get(config.apiBasePath + `/videos/programas?limite=50`)
            .then(response => {
                setListaProgramasVideos(response.data.data)
                setHasError(false)
            })
            .catch(handleError)
            .finally(() => setIsLoadingProgramasVideos(false));
    }


    const handleError = (err) => {
        setHasError(true)
        setErrorMessage((err.response && !!err.response.data.message) ? err.response.data.message : 'Erro inesperado.')
    }

    return (
        <Modal size="lg" isOpen={props.isOpen} toggle={toggle} returnFocusAfterClose={false}>
            <ModalHeader toggle={toggle}>{flagContent ? "Incluir vídeo" : "Inserir vídeo"}</ModalHeader>
            <ModalBody>
                <div className="row no-gutters insert-video">
                    {idVideoPrograma === null ? (
                        <div className="col-12">
                            <div className="row no-gutters">
                                <div className="col-12 text-center">
                                    <strong>Lista de Programas</strong>
                                </div>

                                <div className="col-12 px-3">
                                    {isLoadingProgramasVideos ? (
                                        <div className="row">
                                            <div className="col-12 py-5 text-center">
                                                <div className="spinner-border text-primary" role="status" />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row">
                                            {listaProgramasVideos.length > 0 ? listaProgramasVideos.map((prog, index) => {
                                                return (
                                                    <div onClick={() => selecionaVideoPrograma(prog.idVideoPrograma)} key={`prog-${index}`} className="col-4 p-1 cursor-pointer">
                                                        <img className="img img-fluid img-programa" src={prog.imagem} alt={'capa-' + prog.nome} />
                                                    </div>
                                                )
                                            }) : (
                                                <React.Fragment>
                                                    {hasError ? (
                                                        <div className='col-12 text-center text-danger'>
                                                            <p>{errorMessage}</p>
                                                        </div>
                                                    ) : (
                                                        <div className="col-12 py-2 text-center">
                                                            <p className="m-0">Não há programas disponíveis.</p>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="col-12">
                            <div className="row no-gutters">
                                <div className="col-9 text-left px-2">
                                    <h3>Programa: "{listaProgramasVideos.filter(item => item.idVideoPrograma === idVideoPrograma)[0].nome}"</h3>
                                </div>
                                <div className='col-3 text-right px-2'>
                                    <button className='btn btn-outline-secondary' onClick={() => setVideoPrograma(null)}>voltar</button>
                                </div>
                                <div className="col-12 text-left px-2">
                                    <strong>Lista de Episódios</strong>
                                </div>

                                <div className="col-12 px-3">
                                    {isLoadingEpisodiosVideos ? (
                                        <div className="row">
                                            <div className="col-12 py-5 text-center">
                                                <div className="spinner-border text-primary" role="status" />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row">
                                            {listaEpisodiosVideos.length > 0 ? listaEpisodiosVideos.map((episodio, index) => {
                                                return (
                                                    <div onClick={() => selecionaEpisodio(episodio)} key={`prog-${index}`} className={'col-4 p-2 cursor-pointer' + (episodio.idVideoEpisodio === idEp ? ' episodio-selecionado' : '')}>
                                                        <img className="img img-fluid img-episodio" src={episodio.imagem} alt={'capa-' + episodio.nome} />
                                                        <p><strong>{episodio.nome}</strong></p>
                                                    </div>
                                                )
                                            }) : (
                                                <React.Fragment>
                                                    {hasError ? (
                                                        <div className='col-12 text-center text-danger'>
                                                            <p>{errorMessage}</p>
                                                        </div>
                                                    ) : (
                                                        <div className="col-12 p-2 text-center">
                                                            <p className="m-0">Não há episódios disponíveis para esse programa.</p>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {isLoadingInserirVideo ? (
                                    <div className="col-12 py-4 text-center">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                ) : (
                                    <div className="col-12 py-4 text-center">
                                        <button disabled={!idEp} onClick={() => handleModalVideo({idProg: idVideoPrograma, idEp, nomeEp, tipo: 3, episodio: episodioSelecionado, nomePrograma: nomePrograma()})} className="btn btn-outline-success">{flagContent ? "Incluir vídeo" : "Inserir vídeo"}</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {!!listaEpisodiosVideos && listaEpisodiosVideos.length > 0 && !!paginacaoEpisodiosVideos && (
                        <div className="col-12 mt-2 px-0">
                            <div className="paginacao-videos">
                                <Pagination onChange={onChangePage} current={paginacaoEpisodiosVideos.pagina} total={(paginacaoEpisodiosVideos.totalPaginas * episodiosPorPagina)} pageSize={episodiosPorPagina} />
                                {/* <Pagination onChange={onChangePage} current={pagina} total={200} pageSize={5} /> */}
                            </div>
                        </div>
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
}

export default InsertVideo;